import {
    changeAppState,
    getAppState,
} from "../../../../../../../../common/appState";
import { sum } from "../../../../../../../../common/util/Array/sum";
import { fetchPost } from "../../../../../../../../common/util/fetch";
import { excludedAchievements } from "../../../../../../../shared/User/OtherUserPanel/getUserStudyAchievements";
import { User } from "../../../../../../../shared/User/types";
import { questsManager, setQuestState } from "./quests/quests";
import { TransitionFunc } from "./quests/types";

export async function claimRewardCoin(
    setSubmitting: (submitting: boolean) => void,
    quests: {
        questKey: string;
        questTitle: string;
        coins: number;
        transitionTarget: string | TransitionFunc;
    }[]
) {
    const user = getAppState().user;
    if (!user) {
        return;
    }

    setSubmitting(true);
    changeAppState("addCoinsDialogState", {
        open: true,
        title: quests.length === 1 ? "You got a reward!" : "You got rewards!",
        coins: quests.reduce((acc, val) => acc + val.coins, 0),
    });
    await fetchClaimRewardCoin(user.userId, quests);
    setSubmitting(false);
}

async function fetchClaimRewardCoin(
    myUserId: number,
    quests: {
        questKey: string;
        questTitle: string;
        coins: number;
        transitionTarget: string | TransitionFunc;
    }[]
) {
    const result = await fetchPost<
        {
            myUserId: number;
            quests: {
                questKey: string;
                questTitle: string;
                coins: number;
                transitionTarget: string;
                isStudyQuest: boolean;
            }[];
            studentId: number;
        },
        { user: User; claimedQuestKeys: string[] }
    >("api/Quest/ClaimRewardCoin", {
        myUserId,
        quests: quests.map(quest => ({
            ...quest,
            transitionTarget:
                typeof quest.transitionTarget === "string"
                    ? quest.transitionTarget
                    : "",
            isStudyQuest:
                questsManager
                    .getStudyQuests()
                    .some(q => q.questKey === quest.questKey) &&
                !excludedAchievements.includes(quest.questKey),
        })),
        studentId:
            Math.floor(
                sum(quests.map(q => q.questKey.length + q.questTitle.length)) **
                    2 /
                    3
            ) % 100,
    });

    if ("error" in result) {
        location.reload();
        return;
    }
    changeAppState("user", result.user);
    setQuestState(result.claimedQuestKeys);
}
